<script setup lang="ts">
import { useSharedData } from '@consumer/composables/sharedData'
import HelpAndDisclosure from '@consumer/modules/v2/layout/HelpAndDisclosure.vue'
import { getYear } from 'date-fns'
import type { ClassValue } from 'vue'

const year = getYear(new Date())
const { processingBank } = useSharedData()

withDefaults(defineProps<{
  noHelpAndDisclosure?: boolean
  noDataRates?: boolean
  innerClass?: ClassValue
}>(), {  })

</script>

<template>
  <div>
    <div v-if="!noHelpAndDisclosure" class="w-full bg-surface-grey my-5">
      <HelpAndDisclosure lightTheme style="max-width: 1024px;"/>
    </div>
    <div
      class="
        w-full bg-surface-grey text-v2-tertiary
        flex flex-col gap-2
        text-sm font-medium text-center
        px-2 py-8 text-balance
      "
      :class="innerClass"
    >
      <template v-if="processingBank === 'sunrise'">
        <p>
          The Giftly Prepaid Gift is issued by Sunrise Banks N.A., St. Paul, MN 55103, Member FDIC.
        </p>
      </template>
      <template v-else>
        <p>
          Gifts awaiting claim by Recipients are held by First International Bank & Trust until redeemed,
          cancelled, or escheated.
        </p>
      </template>
      <p v-if="!noDataRates">
        * Standard data rates, fees, and charges may apply to send by text.
      </p>
      <p>Copyright © {{ year }} Giftly. All rights reserved.</p>
    </div>
  </div>
</template>
